module.exports = __webpack_public_path__ + "img/level3addon_idle.9c583732.png";